import { styled } from '@mui/material'

/**
 * For users who get auth/network-request-failed errors (Cannot use <form> tag, nor type="submit" with <button> tag)
 */
export default styled('div')(({ theme }) => ({
  fontFamily: '"Outfit", Arial, sans-serif',
  width: '100%',
  backgroundColor: 'white',
  padding: '20px',
  [theme.breakpoints.not('xs')]: {
    border: '1px solid #DFE1E7',
    borderRadius: '6px',
    padding: '40px 75px',
    marginTop: '46px',
    width: '635px',
    right: 2,
    top: 0
  }
}))
